import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { HeaderBasket } from '@pages/page-cfg-baskets/header-basket';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DayMonth, GrpNameCtrl } from '@documalis/_const/const';

@Component({
    selector: 'app-form-basket',
    templateUrl: './form-basket.component.html',
    styleUrls: ['./form-basket.component.scss'],
    providers: [AutofocusDirective],
})
export class FormBasketComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;

    @Input()
    public dataItem: HeaderBasket = null;

    @Input()
    public bskType = null;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public user_Type: number;
    public firstDayOfWeek: number;
    public userListUsed = [];
    public groupListUsed = [];

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        super(messageService);
        this.firstDayOfWeek = DayMonth.firstDayOfWeek;

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            name: [null, [Validators.required, Validators.pattern(GrpNameCtrl), Validators.minLength(1), Validators.maxLength(255)]],
            label: ['',[Validators.maxLength(255)]],
            desc: '',
            groupListUsed: null,
            userListUsed: null,
        });
        this.initialization();
        this.user_Type = 0;
    }

    ngOnInit() {        
        if (this.dataItem !== null) {
            this.resultForm.patchValue(this.dataItem);
            if (this.dataItem.duplicate === true) {
                this.resultForm.controls['name'].enable();
            } else {
                this.resultForm.controls['name'].disable();
            }
            this.resultForm.patchValue(this.dataItem);
            this.userListUsed = this.dataItem.userListUsed;
            this.groupListUsed = this.dataItem.groupListUsed;                    
        } else {
            this.resultForm.controls['name'].enable();
        }
    }

    ngOnDestroy() {
    }

    public onUserType(event) {
        this.user_Type = event;
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            data: this.resultForm.value,
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            if (this.dataItem) {
                if (this.ctrlDuplicate() === false) {
                    return;
                }
                wRequest = this.setValues(wRequest);
            } else {
            }    
            this.onValidate.emit(wRequest);
        }
    }

    private setValues(aRequest) {
        if (this.dataItem.duplicate === true) {
            aRequest.data.name = this.resultForm.controls.name.value.trim();
        } else {
            aRequest.data.name = this.dataItem.name.trim();
        }
        return aRequest;
    }

    private ctrlDuplicate() {
        if (this.dataItem.duplicate === false) {
            return true;
        }
        if (this.dataItem.name === this.resultForm.controls.name.value.trim()) {
            this._messageService.addWarn(this.translate.instant('Cfb_BasketEqual'));
            return false;
        } else {
            return true;
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private initialization() {
        this.keys = {
            name: {
                label: this.translate.instant('Cfb_Name'),
                pattern: '',
            }
        };
    }
}
